import { definitions } from "api";
import useRecords from "./useRecords";

type Region = definitions["registry_value"];

const useStates = () => useRecords<Region>("states");

export default useStates;
